import React from 'react';

interface NoDataAvailableProps {
  isGenerating: boolean;
  onGenerateAnalysis: () => void;
}

const NoDataAvailable: React.FC<NoDataAvailableProps> = ({ 
  isGenerating, 
  onGenerateAnalysis 
}) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body text-center py-5">
            <i className="fas fa-chart-line fa-3x text-muted mb-3"></i>
            <h3>No Performance Data Available</h3>
            <p className="text-muted mb-4">
              Generate your first performance analysis to see comprehensive insights about your learning progress.
            </p>
            <button
              className="btn btn-primary btn-lg"
              onClick={onGenerateAnalysis}
              disabled={isGenerating}
            >
              {isGenerating ? 'Generating...' : 'Generate Performance Analysis'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoDataAvailable;